export default __webpack_public_path__ + "static/media/imagotype.598219f5.svg";